export default __webpack_public_path__ + "static/media/rrhh-icon.219d8549.png";